import { render } from "./Legend.vue?vue&type=template&id=d5c9df5c&scoped=true&ts=true"
import script from "./Legend.vue?vue&type=script&lang=ts"
export * from "./Legend.vue?vue&type=script&lang=ts"

import "./Legend.vue?vue&type=style&index=0&id=d5c9df5c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c9df5c"]])

export default __exports__